import React from "react";
import TreasuryCoordinatorOrderListing from "./TreasuryCoordinatorOrderListing.js";
function TreasuryCoordinatorStarOrdersListing() {
  return (
    <TreasuryCoordinatorOrderListing
     isStarredPage={true}
      title="Starred Transactions"
    />
  );
}

export default TreasuryCoordinatorStarOrdersListing;
